import { useIntl } from "@grandvisionhq/state";
import { formatDistance, DistanceUnit } from "@grandvisionhq/utils";
import { useStoreFinderContext } from "../../context/StoreFinder/context/StoreFinder/context.js";
const useDistanceUnit = (distance) => {
  const { distanceUnit } = useIntl();
  if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
    if (distance && distance < 1e3) {
      return DistanceUnit.meter;
    }
  }
  return distanceUnit;
};
const useFormattedDistance = (distance) => {
  const { userLocation, isUsingUserLocation } = useStoreFinderContext();
  const { getFormattedLabel } = useIntl();
  const distanceUnit = useDistanceUnit(distance);
  const distanceIncludingUnit = distance && formatDistance(distance, distanceUnit, { separator: " " });
  if (!distanceIncludingUnit) {
    return void 0;
  }
  return userLocation !== void 0 && isUsingUserLocation ? (
    /* show `${distanceIncludingUnit} from you` indication otherwise show just the distance */
    getFormattedLabel("appointments.component.storeFinderItem.distance", {
      labelData: { distance: distanceIncludingUnit }
    })
  ) : distanceIncludingUnit;
};
export {
  useDistanceUnit,
  useFormattedDistance
};
//# sourceMappingURL=use-formatted-distance.js.map
